import { createSelector } from '@ngrx/store';
import { getNewRepeatOrderState } from '@ordersnproducts/modules/new-repeat-order/reducers';

export const getOrderSelectedDetailState = createSelector(getNewRepeatOrderState, state => state && state.orderSelectedDetail);

export const getOrderSelectedDetail = createSelector(getOrderSelectedDetailState, state => state && state.order);

export const getDisabledNavigation = createSelector(getNewRepeatOrderState, state => {
  return state.repeatOrder.disableNavigation;
});

export const getIsExternalLoad = createSelector(getNewRepeatOrderState, state => {
  return state.repeatOrder.external;
});

export const getIsOrderFromStore = createSelector(getNewRepeatOrderState, state => {
  return state.repeatOrder.orderFromStore;
});
